/**
 * Suggested questions the lightbulb offers, keyed by the page id from
 * `agent-view-route.ts`. Pure UI copy for now — the strings are previews of
 * the user's own words, not agent behaviour, so they live client-side. If they
 * ever need to vary per deployment they can be served by the runtime's product
 * catalog instead; the shape here (page id -> readonly strings) is what such an
 * endpoint would return, so the component would not change.
 *
 * Only pages listed here show the bulb. Portfolio Experiments, and the
 * Walkthroughs page (where they also sit under its welcome message).
 */

export const MAX_PAGE_SUGGESTIONS = 5;

const PAGE_SUGGESTIONS: Readonly<Record<string, readonly string[]>> = {
  // The public preview on the private-beta page (a signed-out guest): the two
  // founders' books, as the one-click questions Vega's welcome points to.
  "private-beta": [
    "Tell me about the strategies and performance of mike@retraid's overlays portfolio.",
    "Tell me about the strategies and performance of ironflyguy's roth portfolio.",
  ],
  walkthroughs: [
    "Which walkthrough should I start with?",
    // While progress states are off (WALKTHROUGH_PROGRESS_UI_ENABLED) there is no "last visit" to compare:
    // "What's new since my last visit?",
    "How do I import trades from my broker?",
    "Show me how to create a portfolio",
  ],
  "portfolio.experiments": [
    "What kinds of experiments can you create?",
    "Backtest the wheel on SPY with weekly puts and covered calls",
    "Backtest SPY put credit spreads, taking profit at 50% of the credit",
    "Sell QQQ puts when its close crosses below its 50-day SMA",
    "Buy SPY when its close crosses above the previous calendar month's highest close",
  ],
};

/** Up to five prompts for a page; empty when the page offers none. */
export function suggestionsForPage(pageId: string | null | undefined): readonly string[] {
  if (!pageId) return [];
  return (PAGE_SUGGESTIONS[pageId] ?? []).slice(0, MAX_PAGE_SUGGESTIONS);
}
